"use strict";

/**
 * @file
 * rssPopup.
 */

(function ($, Drupal) {
  Drupal.behaviors.rssPopup = {
    attach: function attach(context) {
      $('.js-rss-popup-close', context).click(function () {
        $('.js-rss-popup').fadeOut();
      });
      $('.js-btn-subscribe', context).click(function () {
        $('.js-rss-popup').fadeIn();
      });
    }
  };
})(jQuery, Drupal);